import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { $getRoot } from 'lexical'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $convertFromMarkdownString, $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown'

/**
 * I made this as I was having problems with WYSIYG and updating with controlled form state
 * - should centralize the logic a bit resetting/setting the data based on the values
 */
const ControlledValuePlugin = ({ value, isMarkdown }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (value === undefined || value === null) return
    editor.getEditorState().read(() => {
      const currentMarkdown = $convertToMarkdownString(TRANSFORMERS)
      if (currentMarkdown === value) return

      editor.update(() => {
        const root = $getRoot()
        root.clear()
        if (isMarkdown && typeof value === 'string') {
          $convertFromMarkdownString(value, TRANSFORMERS)
        }
      }, { discrete: true })
    })
  }, [value, editor, isMarkdown])

  return null
}

ControlledValuePlugin.propTypes = {
  value: PropTypes.string,
  isMarkdown: PropTypes.bool
}

ControlledValuePlugin.defaultProps = {
  value: '',
  isMarkdown: false
}

export default ControlledValuePlugin
